var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilledSuccessStatus = function SvgFilledSuccessStatus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.699 2.463 3.312 4.766l-.633-.677a.346.346 0 0 0-.433-.023.305.305 0 0 0-.087.403l.75 1.22c.073.114.2.184.343.184.137 0 .267-.07.34-.184.12-.156 2.41-2.886 2.41-2.886.3-.307-.063-.577-.303-.344v.004Z",
    fill: "#06C270"
  })));
};
export default SvgFilledSuccessStatus;